module.exports = __webpack_public_path__ + "img/shortland-hanging.769f2845.svg";